import { render, staticRenderFns } from "./comments_detial.vue?vue&type=template&id=45f05755&scoped=true"
import script from "./comments_detial.vue?vue&type=script&lang=js"
export * from "./comments_detial.vue?vue&type=script&lang=js"
import style0 from "./comments_detial.vue?vue&type=style&index=0&id=45f05755&prod&scoped=true&lang=less"
import style1 from "./comments_detial.vue?vue&type=style&index=1&id=45f05755&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f05755",
  null
  
)

export default component.exports